import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;

const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });

export const saveNote = data => {
    return axios.post('/api/v1/notes/', data);
};

export const noteBuilds = data => {
    return axios.post('/api/v1/note_builds/', data);
};

export const noteDelete = id => {
    return axios.delete(`/api/v1/notes/${id}`);
};

export const noteUpdate = (id, data) => {
    return axios.post(`/api/v1/notes/${id}`, data);
};

export const getNotes = params => {
    return axios.get('/api/v1/notes/', { params });
};
